var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5127 2.24128H11.9914C10.7469 2.24128 9.73791 3.24473 9.73791 4.48255V17.9302C9.73791 19.168 10.7469 20.1715 11.9914 20.1715H25.5127C26.7573 20.1715 27.7662 19.168 27.7662 17.9302V4.48255C27.7662 3.24473 26.7573 2.24128 25.5127 2.24128ZM11.9914 0C9.50226 0 7.48438 2.00691 7.48438 4.48255V17.9302C7.48438 20.4059 9.50226 22.4128 11.9914 22.4128H25.5127C28.0019 22.4128 30.0197 20.4059 30.0197 17.9302V4.48255C30.0197 2.00691 28.0019 0 25.5127 0H11.9914Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7519 8.96393H5.2307C3.98611 8.96393 2.97717 9.96739 2.97717 11.2052V24.6529C2.97717 25.8907 3.98611 26.8941 5.2307 26.8941H18.7519C19.9965 26.8941 21.0055 25.8907 21.0055 24.6529V11.2052C21.0055 9.96739 19.9965 8.96393 18.7519 8.96393ZM5.2307 6.72266C2.74152 6.72266 0.723633 8.72956 0.723633 11.2052V24.6529C0.723633 27.1285 2.74152 29.1354 5.2307 29.1354H18.7519C21.2411 29.1354 23.259 27.1285 23.259 24.6529V11.2052C23.259 8.72956 21.2411 6.72266 18.7519 6.72266H5.2307Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyQuestion);
export default __webpack_public_path__ + "static/media/copy-question.344797efcf3205382e9bea1744206efb.svg";
export { ForwardRef as ReactComponent };